import { authHeader } from "../_helpers";
import { handleResponse } from "../_helpers/response";
import config from "../config";
const baseUrl = config.apiGateway.baseUrl;
export const PoliceSideService = {
  PoliceSideCommonSearch,
  getResidentsByPoliceStationSearchByPolice,
  getCriminalsByPoliceStationAreaSearchByPolice,
  getResidentsByPoliceStationIdSearchByPolice,
  PoliceSideSnapShots,
  PoliceSideGraphSnapShots,
  getAccusedListWithTwoOrMoreCount,
  getAccusedListWithTwoOrMoreByIdCount,
  dailyReports,
  getCctnsMapDistrict,
  getGunaCctnsData,
  getArestCctnsData,
};

function PoliceSideCommonSearch(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/PoliceSideCommonSearch/`, requestOptions);
}
function getResidentsByPoliceStationSearchByPolice(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getResidentsByPoliceStationSearchByPolice/`,
    requestOptions,
  );
}
function getCriminalsByPoliceStationAreaSearchByPolice(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getCriminalsByPoliceStationAreaSearchByPolice/`,
    requestOptions,
  );
}
function getResidentsByPoliceStationIdSearchByPolice(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getResidentsByPoliceStationIdSearchByPolice/`,
    requestOptions,
  );
}
function PoliceSideSnapShots(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/PoliceSideSnapShots/`, requestOptions).then(
    handleResponse,
  );
}

function PoliceSideGraphSnapShots(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/PoliceSideGraphSnapShots/`,
    requestOptions,
  ).then(handleResponse);
}
function getAccusedListWithTwoOrMoreCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getAccusedListWithTwoOrMoreCount/`,
    requestOptions,
  ).then(handleResponse);
}
function getAccusedListWithTwoOrMoreByIdCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getAccusedListWithTwoOrMoreByIdCount/`,
    requestOptions,
  ).then(handleResponse);
}

function dailyReports(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/dailyReports/`, requestOptions).then(
    handleResponse,
  );
}
function getCctnsMapDistrict(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/getCctnsMapDistrict/${id}`,
    requestOptions,
  ).then(handleResponse);
}
function getGunaCctnsData(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getGunaCctnsData/`, requestOptions).then(
    handleResponse,
  );
}
function getArestCctnsData(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getArestCctnsData/`, requestOptions).then(
    handleResponse,
  );
}
